import React from "react";
import { notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import { NotificationProps } from "@mantine/notifications/lib/types";

export enum ToastType {
  SUCCESS,
  ERROR,
}

export const showToast = (
  title: string,
  message: string,
  type: ToastType,
  shouldShowToast = true,
): void => {
  shouldShowToast &&
    notifications.show({
      title,
      message,
      icon: type === ToastType.SUCCESS ? <IconCheck /> : <IconX />,
      color: type === ToastType.SUCCESS ? "green" : "red",
      autoClose: false,
      onClose: () => notifications.clean(),
    } as NotificationProps);
};
